import LogoStarOrange from '../../../static/svg/logo-star.svg';
import LogoStarOrangeD from '../../../static/svg/logo-star-white.svg';
import LogoStarBrown from '../../../static/svg/logo-star-brown.svg';
import LogoStarBrownD from '../../../static/svg/logo-star-brown-white.svg';
import LogoStarRed from '../../../static/svg/logo-star-red.svg';
import LogoStarRedD from '../../../static/svg/logo-star-red-white.svg';
import LogoStarGreen from '../../../static/svg/logo-star-green.svg';
import LogoStarGreenD from '../../../static/svg/logo-star-green-white.svg';
import LogoStarViolet from '../../../static/svg/logo-star-violet.svg';
import LogoStarVioletD from '../../../static/svg/logo-star-violet-white.svg';
import React from 'react';
import * as styles from './arrow.module.scss';

interface Props {
  color: string;
  dark?: boolean;
}

export const LogoStarMap: React.FC<Props> = ({ color, dark = false }) => {
  return (
    <>
      {dark ? color === 'orange' && <LogoStarOrangeD /> : color === 'orange' && <LogoStarOrange />}
      {dark ? color === 'brown' && <LogoStarBrownD /> : color === 'brown' && <LogoStarBrown />}
      {dark ? color === 'red' && <LogoStarRedD /> : color === 'red' && <LogoStarRed />}
      {dark ? color === 'violet' && <LogoStarVioletD /> : color === 'violet' && <LogoStarViolet />}
      {dark ? color === 'green' && <LogoStarGreenD /> : color === 'green' && <LogoStarGreen />}
    </>
  );
};
